<template>
  <div class="bg-dashboard">
    <div class="bg-gary-menu-dashbord on-top-header-dashboard">
      <v-container>
        <v-row class>
          <v-flex xs4 sm4 md3 lg3 xl2 class="flex-menu-dsashboard my-1">
            <span class="font-14 my-2 text-w pr-1">ภาค :</span>
            <div class="dropdown">
              <v-select
                class="style-chooser pr-2"
                :items="provinces"
                label="เลือกจังหวัด"
                hide-details
                solo
              ></v-select>
            </div>
          </v-flex>
          <v-flex xs4 sm4 md5 lg6 xl7 class="flex-menu-dsashboard my-1">
            <span class="font-14 my-2 text-w pr-1">เขต :</span>
            <div class="dropdown">
              <v-select
                class="style-chooser pr-2"
                :items="districts"
                label="เลือกเขต"
                solo
                hide-details
              ></v-select>
            </div>
          </v-flex>
          <v-flex xs4 sm4 md4 lg3 xl3 class="my-1">
            <div class="flex-menu-dsashboard float-Doughnutchart">
              <span class="font-14 my-2 text-w pr-1">ระยะเวลา :</span>
              <div class="dropdown">
                <v-select
                  class="style-chooser pr-2"
                  label="เลือกเดือน"
                  solo
                  hide-details
                ></v-select>
              </div>
            </div>
          </v-flex>
        </v-row>
      </v-container>
    </div>

    <v-container>
      <v-row justify="space-between my-2">
        <v-flex xs12 sm12 md12 lg9 xl10 class="container">
          <v-card class="my-2">
            <v-container>
              <v-row class="py-2 px-2">
                <v-flex xs12 sm12 md12 lg12 xl12>
                  <div class>
                    <span class="font-16 font-Prompt font-w-600 text-black mx-1">จำนวน VISIT</span>
                    <span class="mx-2">
                      <span class="font-16 font-Prompt font-w-500 text-gary-date">ผ่านเป้า :</span>
                      <span class="font-18 font-Prompt font-w-600 text-black">{{
                        getGraphVisitAgency.passtarget
                      }}</span>
                      <span class="font-12 font-Prompt font-w-500 text-gary-date"
                        >/{{ getGraphVisitAgency.shop_num }} ร้าน</span
                      >
                    </span>
                    <span class="font-16 text-blue-d">{{ getGraphVisitAgency.percent }}%</span>
                  </div>
                </v-flex>
              </v-row>
              <vue-scroll :ops="ops" ref="vs">
                <v-row class="visit-agent-container">
                  <v-flex>
                    <v-row
                      class="py-2 px-5"
                      v-for="(visitAgent, agentIndex) in getGraphVisitAgency.shop_list"
                      :key="agentIndex"
                    >
                      <v-flex xs12 sm3 md2 lg2 xl2>
                        <div class="float-chart px-2 text-chart-left-right">
                          <span class="text-red-d font-14 font-w-400">{{ visitAgent.name }}</span>
                        </div>
                      </v-flex>
                      <v-flex xs9 sm8 md9 lg9 xl9 class="progress-bar-dashboard">
                        <div
                          class="progress_detail"
                          :style="{ left: visitAgent.percent + '%' }"
                        ></div>

                        <div class="my-1">
                          <v-progress-linear
                            class="progress-visit-red"
                            :buffer-value="visitAgent.targetperday"
                            :value="visitAgent.percent"
                            :color="'red'"
                            height="16"
                          ></v-progress-linear>
                        </div>
                      </v-flex>
                      <v-flex xs3 sm1 md1 lg1 xl1>
                        <div class="px-1 text-center">
                          <span class="text-red-d font-14 font-w-500"
                            >{{ visitAgent.percent }}%</span
                          >
                        </div>
                      </v-flex>
                    </v-row>
                  </v-flex>
                </v-row>
              </vue-scroll>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 lg3 xl2 class="container">
          <div class="float-Doughnutchart">
            <v-card class="my-2">
              <v-container>
                <div class="font-Prompt my-2">
                  <span class="text-16 font-w-500 text-black">จำนวนร้านตกเป้า</span>
                  <span class="text-16 font-w-500 text-gary-date">(รายวัน) :</span>
                </div>
                <div class="my-4">
                  <Doughnutchart :glabels="donutData" />
                </div>
                <div class="text-center">
                  <span class="font-21 text-red-d font-w-500">{{
                    getGraphMissionTarget.total_visited
                  }}</span>
                  <span class="font-14 text-gary-date"
                    >/
                    {{
                      Math.abs(getGraphMissionTarget.total_targetperday) +
                        getGraphMissionTarget.total_notvisit
                    }}</span
                  >
                  <span class="font-12 text-gary-date">ร้าน</span>
                </div>
                <div class="progress-chart-w m-auto">
                  <v-progress-linear
                    color="red"
                    :value="
                      (getGraphMissionTarget.total_visited /
                        getGraphMissionTarget.total_targetperday) *
                        100
                    "
                  ></v-progress-linear>
                  <v-divider></v-divider>
                </div>
                <div class="text-center">
                  <span class="text-gary-date font-12">เช้าเยี่ยม</span>
                  <span class="font-14 text-black">{{ getGraphMissionTarget.total_visited }}</span>
                  <span class="font-12 text-gary-date">ครั้ง</span>
                </div>
              </v-container>
            </v-card>
          </div>
        </v-flex>
      </v-row>
      <v-row class="my-4">
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-container>
              <v-row class="px-5 my-2">
                <v-flex xs12 sm6 md6 lg6 xl6>
                  <div class>
                    <span class="font-18 font-Prompt font-w-600 text-black">จำนวน VISIT</span>
                    <span class="font-16 font-Prompt font-w-500 text-gary-date">(ร้าน)</span>
                    <span class="font-18 font-Prompt font-w-600 text-black mx-2">รายคน</span>
                    <span class="font-16 font-w-400 mx-2 font-Prompt text-gary-date"
                      >ผ่านเป้า(รายวัน) :</span
                    >
                    <span class="font-18 font-Prompt font-w-600 text-black">2</span>
                    <span class="font-12 font-Prompt font-w-500 text-gary-date">/80 คน</span>
                    <span class="font-16 text-blue-d mx-2">25%</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md6 lg6 xl6>
                  <div class="float-right">
                    <span class="lightishblue-dashboard mx-1"></span>
                    <span class="font-12 text-gary-date my-1 mx-2">จำนวน VISIT(ร้าน​)</span>
                    <span class="lightishblue-dashboard-2 mx-1"></span>
                    <span class="font-12 text-gary-date my-1 mx-2">เป้ารายวัน</span>
                    <span class="lightishblue-dashboard-3 mx-1"></span>
                    <span class="font-12 text-gary-date my-1 mx-2">เป้ารายเดือน</span>
                  </div>
                </v-flex>
              </v-row>
              <div class="my-2">
                <Stackedbar :slabels="stackData" />
              </div>
            </v-container>
          </v-card>
        </v-flex>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Doughnutchart from '@/components/Doughnutchart.vue'
import Stackedbar from '@/components/Stackedbar.vue'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      provinces: [
        'ภาคเหนือ',
        'ภาคตะวันออกเฉียงเหนือ',
        'ภาคตะวันตก',
        'ภาคกลาง',
        'ภาคตะวันออก',
        'ภาคใต้'
      ],
      districts: [
        'คลองสาน',
        'คลองสามวา',
        'คลองเตย',
        'คันนายาว',
        'จตุจักร',
        'จอมทอง',
        'ดอนเมือง',
        'ดินแดง',
        'ดุสิต',
        'ตลิ่งชัน',
        'ทวีวัฒนา',
        'ทุ่งครุ',
        'ธนบุรี',
        'บางกอกน้อย',
        'บางกอกใหญ่',
        'บางกะปิ',
        'บางขุนเทียน',
        'บางคอแหลม',
        'บางซื่อ',
        'บางนา',
        'บางบอน',
        'บางพลัด',
        'บางรัก',
        'บางเขน',
        'บางแค',
        'บึงกุ่ม',
        'ปทุมวัน',
        'ประเวศ',
        'ป้อมปราบศัตรูพ่าย',
        'พญาไท',
        'พระนคร',
        'พระโขนง',
        'ภาษีเจริญ',
        'มีนบุรี',
        'ยานนาวา',
        'ราชเทวี',
        'ราษฎร์บูรณะ',
        'ลาดกระบัง',
        'ลาดพร้าว',
        'วังทองหลาง',
        'วัฒนา',
        'สวนหลวง',
        'สะพานสูง',
        'สัมพันธวงศ์',
        'สาทร',
        'สายไหม',
        'หนองจอก',
        'หนองแขม',
        'หลักสี่',
        'ห้วยขวาง'
      ],
      ops: {
        scrollPanel: {
          scrollingX: false
        },
        bar: {
          background: 'rgba(0, 0, 0, 0.87)',
          keepShow: false,
          size: '10px',
          minSize: 0.2
        }
      },
      getGraphVisitAgency: [],
      getGraphMissionTarget: [],
      donutData: {
        labels: [],
        datasets: [
          {
            label: '# of Votes',
            data: [],
            backgroundColor: []
          }
        ]
      },
      stackData: {
        labels: [],
        datasets: [
          {
            label: 'จำนวน VISIT',
            backgroundColor: '#4880ff',
            stack: 'Stack 0',
            data: []
          },
          {
            label: 'เป้ารายวัน',
            backgroundColor: '#b8cbf6',
            stack: 'Stack 0',
            data: []
          },
          {
            label: 'เป้ารายเดือน',
            backgroundColor: '#e0e9ff',
            stack: 'Stack 0',
            data: []
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      shop: (state) => state.auth.shop
    })
  },

  created() {
    this.$nextTick(function() {
      this.$store.dispatch('setTitle', 'สรุปข้อมูล')
    })
    const paramUser = this.$route.query.userId
    this.$store
      .dispatch('auth/initAuth', paramUser)
      .then((result) => {})
      .catch(() => this.$router.push('/'))

    this.callGraphData()
  },
  components: {
    Doughnutchart,
    Stackedbar
  },

  methods: {
    getRandomColor() {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    callGraphData() {
      const paramUser = this.$route.query.userId
      let userId
      if (paramUser) {
        userId = paramUser
      } else {
        userId = 2
      }
      this.$store
        .dispatch('dashboard/getGraphVisitAgency', { shop_id: this.shop.id, user_id: this.user.id })
        .then((res) => {
          this.getGraphVisitAgency = res
        })

      this.$store
        .dispatch('dashboard/getGraphMissionTarget', {
          shop_id: this.shop.id,
          user_id: this.user.id
        })
        .then((res) => {
          this.getGraphMissionTarget = res
          this.donutData.datasets[0].data = []
          this.donutData.datasets[0].backgroundColor = []
          res.shop_list.map((data, i) => {
            this.donutData.labels.push(data.customer_name)
            this.donutData.datasets[0].data.push(+data.customermisstarget)
            this.donutData.datasets[0].backgroundColor.push(this.getRandomColor())
          })
        })

      this.$store
        .dispatch('dashboard/getGraphVisitSales', { shop_id: this.shop.id, user_id: this.user.id })
        .then((res) => {
          const sliceData = res.slice(0, 20)
          let total_customer, customerperdate, total_visited, calcGraphTarget, calcGraphVisit
          sliceData.map((result, i) => {
            total_customer = result.total_customer
            customerperdate = result.customerperdate
            total_visited = result.total_visited

            calcGraphVisit = customerperdate - total_visited
            if (calcGraphVisit <= 0) {
              customerperdate = 0
            } else {
              customerperdate = calcGraphVisit
            }

            calcGraphTarget = total_customer - total_visited - customerperdate
            if (calcGraphTarget <= 0) {
              total_customer = 0
            } else {
              total_customer = calcGraphTarget
            }

            //   console.log(calcGraphTarget)
            // console.log(result.total_visited,result.customerperdate,result.total_visited,calcGraphTarget)
            this.stackData.labels.push(result.user_name)
            this.stackData.datasets[0].data.push(total_visited)
            this.stackData.datasets[1].data.push(customerperdate)
            this.stackData.datasets[2].data.push(total_customer)
          })
        })
    }
  }
}
</script>
<style scoped>
.style-chooser >>> .v-input__control {
  min-height: 39px !important;
  max-width: 160px !important;
}
.style-chooser >>> .v-label {
  font-size: 14px !important;
}

.style-chooser .v-input__control {
  min-height: 39px !important;
  width: 150px;
}
</style>
